import { Component, Input } from '@angular/core';  
import { ConfirmDialogService } from "./services/confirm-dialog.service";  
  
@Component({  
    selector: 'app-confirm-dialog',  
    templateUrl: 'confirm-dialog.component.html'  
    //styleUrls: ['confirm-dialog.component.css']  
})  
export class ConfirmDialogComponent {  
    message: any; 
    alert: boolean = false;
    logoff: boolean = false;
    constructor(  
        private confirmDialogService: ConfirmDialogService  
    ) { }  
  
    ngOnInit() {  
        //this function waits for a message from alert service, it gets   
        //triggered when we call this from any other component  
        this.confirmDialogService.getMessage().subscribe(message => { 
            if (message != undefined) {
                if (message.text == 'logout') {
                    message.text = 'Are you sure you want to Log Off?';
                    this.alert = false;
                    this.logoff = true;
                }
                else {
                    this.alert = true;
                    this.logoff = false;
                }
            }
            this.message = message;  
        });  
    }  
}  